import { Stack } from 'components/Stack';
import { useDetectDevice } from 'hooks';
import { PrepareReturnShipmentSteps, DropOffLocation } from './components';
import {
  HorizontalLine,
  StepDownloadInstructionsContainer,
} from './StepDownloadInstructions.styles';
import { ReturnShipment } from '../../../../models/ReturnShipment.model';

interface StepDownloadInstructionsProps {
  shipment: ReturnShipment;
}

const StepDownloadInstructions = ({
  shipment,
}: StepDownloadInstructionsProps): JSX.Element => {
  const { isMobile, isDesktop } = useDetectDevice();
  const shipmentPk = shipment.returnTicket?.shipmentPk;
  const carrierId = shipment.orgCarrierConfig?.carrier?.carrierId;

  return (
    <StepDownloadInstructionsContainer>
      <Stack gap={24} direction="column">
        {isDesktop && (
          <>
            <PrepareReturnShipmentSteps />
            <HorizontalLine />
            <DropOffLocation shipmentPk={shipmentPk} carrierId={carrierId} />
          </>
        )}
        {isMobile && (
          <>
            <DropOffLocation shipmentPk={shipmentPk} carrierId={carrierId} />
            <HorizontalLine />
            <PrepareReturnShipmentSteps />
          </>
        )}
      </Stack>
    </StepDownloadInstructionsContainer>
  );
};

export { StepDownloadInstructions };
